module.exports = __webpack_public_path__ + "img/sold.b2c4b804.png";